//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import header_menu from './header.menu'
import userbar from './userbar'


export default {
  name: "mobile_menu",
  components: {
    header_menu,
    userbar
  },
  props: {
    header_height: undefined
  },
  data() {
    return {
      expand: false,
    }
  },
  methods: {
    onLeft: function () {

    },
    onRight: function () {

    },
    loginout: function () {
      console.log('loginout click');
      this.$store.commit('loginout');
    },
    show_login_dialog: function (login_message = '尚未登录，请先登录或注册') {
      this.login_message = login_message;
      this.confirm_login = true;
    }
  }
}
